import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import CallLogsTable from "./CallLogsTable";
import CallRecordingsTable from "./CallRecordingsTable";
import { getCallLogs, getCallRecordings } from "../../redux/actions/callLogsAction";
import { TabView, TabPanel } from "primereact/tabview";

const CallLogs = () => {
    const history = useNavigate();
    const dispatch = useDispatch();

    let allCallLogs = useSelector((state) => state.callLogs.allCallLogs);
    let allCallRecordings = useSelector((state) => state.callLogs.allCallRecordings);

    const [loading, setLoading] = useState(false);
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [search, setSearch] = useState("");
    const [activeTab, setActiveTab] = useState(0);

    const isRecordingsTab = activeTab === 2;
    const callType = activeTab === 0 ? "FREE" : "MASKED";

    useEffect(() => {
        setPage(1);
        setSearch("");
    }, [activeTab]);

    useEffect(() => {
        setPage(1);
    }, [search]);

    useEffect(() => {
        if (isRecordingsTab) {
            dispatch(getCallRecordings(page, limit, search));
        } else {
            dispatch(getCallLogs(page, limit, search, callType));
        }
    }, [dispatch, page, limit, search, callType, isRecordingsTab]);

    const mapRows = (source) => {
        let rows = source?.data || [];
        return rows.length > 0
            ? rows.map((item) => ({ ...item, time: new Date(item.time) }))
            : [];
    };

    const filteredLogs = mapRows(allCallLogs);
    const filteredRecordings = mapRows(allCallRecordings);

    const logsTotal = allCallLogs?.totalRecords || 0;
    const recordingsTotal = allCallRecordings?.totalRecords || 0;

    const heading = activeTab === 0 ? "Free Call Logs" : "Masked Call Logs";

    return (
        <div className="col-12">
            <TabView activeIndex={activeTab} onTabChange={(e) => setActiveTab(e.index)}>
                <TabPanel header="Free Calls">
                    <CallLogsTable heading={heading} allCallLogs={filteredLogs} loading={loading} history={history} search={search} setSearch={setSearch} page={page} limit={limit} totalRecords={logsTotal} setPage={setPage} setLimit={setLimit} callType={callType} />
                </TabPanel>
                <TabPanel header="Masked Calls">
                    <CallLogsTable heading={heading} allCallLogs={filteredLogs} loading={loading} history={history} search={search} setSearch={setSearch} page={page} limit={limit} totalRecords={logsTotal} setPage={setPage} setLimit={setLimit} callType={callType} />
                </TabPanel>
                <TabPanel header="Call Recordings">
                    <CallRecordingsTable heading="Free Call Recordings" allCallRecordings={filteredRecordings} loading={loading} history={history} search={search} setSearch={setSearch} page={page} limit={limit} totalRecords={recordingsTotal} setPage={setPage} setLimit={setLimit} />
                </TabPanel>
            </TabView>
        </div>
    );
};

export default CallLogs;
